import { render } from "./CustomProcenaViewComponent.vue?vue&type=template&id=80f88f9c&scoped=true"
import script from "./CustomProcenaViewComponent.vue?vue&type=script&lang=js"
export * from "./CustomProcenaViewComponent.vue?vue&type=script&lang=js"

import "./CustomProcenaViewComponent.vue?vue&type=style&index=0&id=80f88f9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-80f88f9c"

export default script